import { render, staticRenderFns } from "./VestingEvent.vue?vue&type=template&id=35a2764c"
import script from "./VestingEvent.vue?vue&type=script&lang=js"
export * from "./VestingEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports